module.exports = __webpack_public_path__ + "static/img/lifestyle_04.9a8aa7bb.jpg";